import {
    IonAlert,
    IonBackButton,
    IonButtons,
    IonCol,
    IonContent,
    IonGrid,
    IonHeader,
    IonPage,
    IonRow,
    IonTitle,
    IonToolbar,
    isPlatform
} from "@ionic/react"
import { useSelector } from "react-redux";

import { useHistory, useParams } from "react-router";
import { RootState } from "../../store/rootReducer";
import { UserTemplateListContainer } from "./components/UserTemplateListContainer";
import { UserTemplateSearchBar } from "./components/UserTemplateSearchBar";


export const UserTemplateAgreement = () => {
    const { id }: { id: string } = useParams();
    const history = useHistory();
    const userRole = useSelector((state: RootState) => state.userShow.userRoles!);

    const handleAlertView = () => {
        history.replace(`/app/rrhh/usuarios/${id}`);
    }

    return (
        <IonPage>
            <IonHeader class="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton
                            text={isPlatform("ios") ? "Usuario" : ""}
                            defaultHref={`/app/rrhh/usuarios/${id}`}
                            color="light"
                        />
                    </IonButtons>
                    <IonTitle>Asociar plantilla</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <section className="ion-padding">
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <UserTemplateSearchBar />
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                    <UserTemplateListContainer />
                </section>
            </IonContent>
            <IonAlert
                isOpen={userRole.length === 0}
                onDidDismiss={handleAlertView}
                cssClass="my-custom-class"
                header={'Usuario sin UserRole'}
                subHeader={'Es necesario para seguir con el proceso'}
                message={'Por favor, contáctese con los administradores del sistema.'}
                buttons={['OK']}
            />
        </IonPage>
    )
}